export default __webpack_public_path__ + "static/media/undraw_two_factor_authentication_namy.afd93324.svg";